import { AdminUser, AdminUserDetailModel } from "../crud/adminUser";
import { Customer } from "../crud/customer";

import { getUserDisplayName } from "../crud/adminUser/model";

import { Location } from "redux-little-router";

export const getUserDisplayNameAndTeam = (adminUser: AdminUserDetailModel, teams: Team[]): string | undefined => {
    const userDisplayName = getUserDisplayName(adminUser);
    const team = teams.find(t => t.members.some(m => m.id === adminUser.id));
    return team ? `${userDisplayName} (${team.name})` : userDisplayName;
};

export interface TeamListModel {
    readonly id: string;
    readonly name: string;
    readonly leaders: { name: string; id: string }[];
    readonly members: { name: string; id: string }[];
    readonly customers: { name: string; id: string }[];
}

export interface TeamDetailModel extends TeamListModel {
    readonly email: string;
    readonly phoneNumber: string;
}

export type Team = TeamListModel | TeamDetailModel;

export interface TeamCreateModel {
    name: string;
    email: string;
    phoneNumber: string;
    leaderIds: string[];
    memberIds: string[];
    customerIds: string[];
}

export interface TeamEditModel {
    id: string;
    name: string;
    email: string;
    phoneNumber: string;
    leaderIds: string[];
    memberIds: string[];
    customerIds: string[];
}

export interface TeamState {
    readonly teams: Team[];
    readonly adminUsers: AdminUser[];
    readonly customers: Customer[];
}

export type AppState = TeamState & { router: Location };
